import api from '@motionelements/core/src/api/base-api-v2';

const baseUrl = '/v2/artist/uploads';

export const listUploadFail = async (params, axiosConfig) => {
  params = params || {};

  const config = {
    params: {
      status: 'failed',
      ...api.getLocaleParams(),
      ...(params || {}),
    },
    ...(axiosConfig || {}),
  };

  return api.request('get', baseUrl, config);
};

export const deleteUploadFails = async (ids) => {
  if (!ids.length) return false;

  return api.request('delete', baseUrl, {
    data: {
      status: 'failed',
      ids: ids,
    },
  });
};
